import { render, staticRenderFns } from "./CustomerSelectList.vue?vue&type=template&id=5d8a0704&scoped=true&"
import script from "./CustomerSelectList.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelectList.vue?vue&type=style&index=0&id=5d8a0704&scoped=true&lang=css&"
import style1 from "./CustomerSelectList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a0704",
  null
  
)

export default component.exports